import React from 'react'
import { useAuth } from './Components/AuthProvider/AuthProvider'
import { Dashboard, LoanProviders } from './Pages/Frontend/Interface/Index'

export const ConditionalRouting = () => {
  const { user } = useAuth()

  return user.loanProviderAdminRole === true ? <LoanProviders /> : <Dashboard />
}
